import React from "react";
import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const ServiceMap = ({ blok }) => (
  <div className="wrap">
    <div className="servicemap-wrap inner-wrap">
      <h2 className=" text-2xl merriweather">{blok.subheadline}</h2>
      {blok.image && (
        <img className="servicemap-img" src={blok.image.filename} alt="" />
      )}
      {blok.linkimage && (
        <Link target="_blank" href={blok.linkimage} >
            <img
              className="servicemap-img cursor-pointer"
              src={blok.imagelink.filename}
              alt="img"
            />
        </Link>
      )}

      <Link target="_blank" href={blok.link} >
          <button className="button-default">{blok.button}</button>
      </Link>
    </div>
  </div>
);

export default ServiceMap;
